import { call } from 'redux-saga/effects'
import { getInterviewRequestCompetition } from '../apiModules/interviewRequests'

export function* fetchInterviewRequestCompetitionEntitiesSaga(interviewRequestId) {
  const response = yield call(getInterviewRequestCompetition, interviewRequestId)
  return response
}
